import t from "../../utils/translation/translator";

// The common attributes of a configuration object between retrofit, cartesian and MC12
export const DEFAULT_CONFIGURATION = {
  configId: null,
  configName: t("msizer.ui.my-configuration"),
  currentStepId: null,
  country: window.msizerConfiguration?.locale.split("-")[1] || "WW",
  locale: window.msizerConfiguration?.locale || "en-WW",
  dateFormat: "dd_mm_yyyy",
  host: "www.se.com",
  configStatus: "IN_PROGRESS"
};

export const EVENTS_DATA = {
  locale: "en-WW",
  tags: {
    startPage: "Start page",
    finalizeStep: "Finalize step",
    specifySelectStep: "Specify Select step",
    applicationSettingsStep: "Application inputs",
    specifySelectRecap: "SpecifySelect recap",
    specifySelectTable: "SpecifySelect table",
    specifySelectCompare: "SpecifySelect compare",
    bundleSelection: "Bundle selection",
    savedConfigCard: "Saved conf card",
    fromComparator: "From comparator",
    fromTable: "From table",
    fromId: "From ID",
    fromEmail: "From email",
    fromList: "From list",
    reopennedConfig: "Reopenned configuration",
    none: "N/A"
  },
  types: {
    startConf: "START_CONF",
    copyConfId: "COPY_CONF_ID",
    print: "PRINT",
    duplicateConf: "DUPLICATE",
    deleteConf: "DELETE",
    editAxisName: "EDIT_AXIS_NAME",
    deleteAxis: "DELETE_AXIS",
    duplicateAxis: "DUPLICATE_AXIS",
    selectBundle: "SELECT",
    compare: "COMPARE",
    startSelection: "START_SELECTION",
    continueConf: "CONTINUE_CONF",
    cancelConfInProgress: "CANCEL_CONF_INPROGRESS",
    sendMail: "SEND",
    shareMail: "SHARE",
    addToFavourites: "ADD_FAVOURITES",
    addToMyProject: "ADD_TO_MY_PROJECT",
    export: "EXPORT",
    exportHiveFile: "EXPORT_HIVE_FILE",
    exportXLS: "EXPORT_XLS",
    exportCAD: "EXPORT_CAD",
    download: "DOWNLOAD",
    save: "SAVE",
    rename: "RENAME",
    reOpen: "REOPEN",
    cancelCurrentConf: "CANCEL_CURRENT_CONF",
    openProduct: "OPEN_PRODUCT",
    changeBundle: "CHANGE_BUNDLE",
    editInput: "EDIT_INPUT",
    editMachineSettings: "EDIT_MACHINE SETTINGS",
    addAxis: "ADD_AXIS",
    resetFilters: "RESET_FILTERS",
    unfinishedConf: "UNFINISHED_CONF",
    error: "ERROR",
    errorFilters: "ERROR_FILTERS"
  }
};

export const STEPS = {
  RETROFIT: {
    START: {
      id: 1,
      label: "start",
      done: false,
      status: "IN_PROGRESS"
    },
    APPLICATION_SETTINGS: {
      id: 2,
      label: "msizer.ui.stepper.app_settings",
      done: false,
      status: "IN_PROGRESS"
    },
    SPECIFY_SELECT: {
      id: 3,
      label: "msizer.ui.stepper.specify_select",
      done: false,
      status: "IN_PROGRESS"
    },
    SPECIFY: {
      id: 3_1,
      label: "msizer.ui.stepper.specify",
      done: true,
      status: "IN_PROGRESS"
    },
    SELECT: {
      id: 3_2,
      label: "msizer.ui.stepper.select",
      done: false,
      status: "IN_PROGRESS"
    },
    SAVEANDSHARE: {
      id: 5,
      label: "msizer.ui.stepper.save_and_share",
      done: false,
      status: "FINISHED"
    }
  },
  CARTESIAN: {
    START: {
      id: 1,
      label: "start",
      done: false,
      status: "IN_PROGRESS"
    },
    KINEMATICS: {
      id: 2,
      label: "cartesian.ui.stepper.kinematics",
      done: false,
      status: "IN_PROGRESS"
    },
    MECHANICS: {
      id: 3,
      label: "cartesian.ui.stepper.mechanics",
      done: false,
      status: "IN_PROGRESS"
    },
    DYNAMICS: {
      id: 4,
      label: "cartesian.ui.stepper.dynamics",
      done: false,
      status: "IN_PROGRESS"
    },
    AXIS_SELECTION: {
      id: 5,
      label: "cartesian.ui.stepper.axisselection",
      done: false,
      status: "IN_PROGRESS"
    },
    AXIS_OPTIONS: {
      id: 6,
      label: "cartesian.ui.stepper.axisoptions",
      done: false,
      status: "IN_PROGRESS"
    },
    // CARTESIAN_ACCESSORIES: {
    //   id: 7,
    //   label: "msizer.cartesian.stepper.accessories",
    //   done: false,
    //   status: "IN_PROGRESS"
    // },
    FINALIZE_CARTESIAN: {
      id: 8,
      label: "cartesian.ui.stepper.finalize",
      done: false,
      status: "FINISHED"
    }
  },
  MC12: {
    START: {
      id: 1,
      label: "start",
      done: false,
      status: "IN_PROGRESS"
    },
    BUILD_TRACK: {
      id: 2,
      label: "mc12.ui.steper.build_track",
      done: false,
      status: "IN_PROGRESS"
    },
    ELECTRICAL_INSTALLATION: {
      id: 3,
      label: "mc12.ui.steper.elecrical_installation",
      done: false,
      status: "IN_PROGRESS"
    },
    COMMUNICATION: {
      id: 4,
      label: "mc12.ui.steper.communication",
      done: false,
      status: "IN_PROGRESS"
    },
    ACCESSORIES: {
      id: 5,
      label: "mc12.ui.steper.accessories",
      done: false,
      status: "IN_PROGRESS"
    },
    FINALIZE: {
      id: 6,
      label: "mc12.ui.steper.finalize",
      done: false,
      status: "FINISHED"
    }
  },
  INTEGRATED_DRIVES: {
    START: {
      id: 1,
      label: "start",
      done: false,
      status: "IN_PROGRESS"
    },
    SPECIFY_AND_CONFIGURE: {
      id: 2,
      label: "integrated_drives.ui.stepper.specify_and_configure",
      done: false,
      status: "IN_PROGRESS"
    },
    FINALIZE: {
      id: 3,
      label: "msizer.ui.stepper.finalize",
      done: false,
      status: "FINISHED"
    }
  }
};

// commonData.js

export const STEP_LABELS = {
  RETROFIT: {
    [STEPS.RETROFIT.START.id]: STEPS.RETROFIT.START.label,
    [STEPS.RETROFIT.APPLICATION_SETTINGS.id]: STEPS.RETROFIT.APPLICATION_SETTINGS.label,
    [STEPS.RETROFIT.SPECIFY_SELECT.id]: STEPS.RETROFIT.SPECIFY_SELECT.label,
    [STEPS.RETROFIT.SPECIFY.id]: STEPS.RETROFIT.SPECIFY.label,
    [STEPS.RETROFIT.SELECT.id]: STEPS.RETROFIT.SELECT.label,
    [STEPS.RETROFIT.SAVEANDSHARE.id]: STEPS.RETROFIT.SAVEANDSHARE.label
  },
  CARTESIAN: {
    [STEPS.CARTESIAN.START.id]: STEPS.CARTESIAN.START.label,
    [STEPS.CARTESIAN.KINEMATICS.id]: STEPS.CARTESIAN.KINEMATICS.label,
    [STEPS.CARTESIAN.MECHANICS.id]: STEPS.CARTESIAN.MECHANICS.label,
    [STEPS.CARTESIAN.DYNAMICS.id]: STEPS.CARTESIAN.DYNAMICS.label,
    [STEPS.CARTESIAN.AXIS_SELECTION.id]: STEPS.CARTESIAN.AXIS_SELECTION.label,
    [STEPS.CARTESIAN.AXIS_OPTIONS.id]: STEPS.CARTESIAN.AXIS_OPTIONS.label,
    [STEPS.CARTESIAN.FINALIZE_CARTESIAN.id]: STEPS.CARTESIAN.FINALIZE_CARTESIAN.label
  },
  MC12: {
    [STEPS.MC12.START.id]: STEPS.MC12.START.label,
    [STEPS.MC12.BUILD_TRACK.id]: STEPS.MC12.BUILD_TRACK.label,
    [STEPS.MC12.ELECTRICAL_INSTALLATION.id]: STEPS.MC12.ELECTRICAL_INSTALLATION.label,
    [STEPS.MC12.COMMUNICATION.id]: STEPS.MC12.COMMUNICATION.label,
    [STEPS.MC12.ACCESSORIES.id]: STEPS.MC12.ACCESSORIES.label,
    [STEPS.MC12.FINALIZE.id]: STEPS.MC12.FINALIZE.label
  },
  INTEGRATED_DRIVES: {
    [STEPS.INTEGRATED_DRIVES.START.id]: STEPS.INTEGRATED_DRIVES.START.label,
    [STEPS.INTEGRATED_DRIVES.SPECIFY_AND_CONFIGURE.id]: STEPS.INTEGRATED_DRIVES.SPECIFY_AND_CONFIGURE.label,
    [STEPS.INTEGRATED_DRIVES.FINALIZE.id]: STEPS.INTEGRATED_DRIVES.FINALIZE.label
  }
};

// Data layer analytics

export const DATA_LAYER_EVENT_NAMES = {
  PAGE_VIEW: "page_view",
  ADD_TO_CART: "add_to_cart",
  FILE_DOWNLOAD: "file_download",
  CTA_CLICK: "cta_click"
};
